import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Menu Items
export const getMenuItems = async (category = null) => {
  try {
    const params = category ? { category } : {};
    const response = await api.get('/menu-items', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching menu items:', error);
    throw error;
  }
};

export const getFeaturedItems = async () => {
  try {
    const response = await api.get('/menu-items/featured');
    return response.data;
  } catch (error) {
    console.error('Error fetching featured items:', error);
    throw error;
  }
};

export const getFamousItems = async () => {
  try {
    const response = await api.get('/menu-items/famous');
    return response.data;
  } catch (error) {
    console.error('Error fetching famous items:', error);
    throw error;
  }
};

// Contact
export const submitContactForm = async (formData) => {
  try {
    const response = await api.post('/contact', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

// Settings
export const getSettings = async () => {
  try {
    const response = await api.get('/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

// Contact Messages
export const getContactMessages = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.get('/contact/messages', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching contact messages:', error);
    throw error;
  }
};

export default api;
